export default "__VITE_ASSET__D0Tw2qZn__";